import * as React from "react"
import { VStack, Button, Box, Text } from "@chakra-ui/react"
import { useForm } from "react-hook-form"
import { useMutation } from "react-query"
import { Link, useNavigate, useParams } from "react-router-dom"

import { ReactComponent as Logo } from "../assets/images/logo.svg"
import { Form } from "../components/Form"
import { Input } from "../components/Input"
import { fetcher } from "../lib/fetcher"
import { useToast } from "../lib/hooks/useToast"
import { useDocumentTitle } from "../lib/hooks/useDocumentTitle"

export const ResetPassword = () => {
  useDocumentTitle("Reset password")

  const { token, uuid } = useParams()
  const toast = useToast()
  const navigate = useNavigate()
  const defaultValues = { password: "" }
  const form = useForm({ defaultValues })

  // TODO: Add error typings
  const { mutateAsync: reset, isLoading } = useMutation<
    { detail: { new_password: any; token: any } },
    unknown,
    typeof defaultValues
  >((data) =>
    fetcher("password/reset/", {
      body: JSON.stringify({ new_password: data.password, token, uuid }),
      method: "post",
    }),
  )
  const handleSubmit = async (data: typeof defaultValues) => {
    try {
      const res = await reset(data)
      if (res?.detail) {
        toast({
          description:
            res.detail?.token?.[0].message ||
            res.detail?.new_password?.[0].message ||
            "Error resetting password",
          status: "error",
        })
      } else {
        toast({
          title: "Password reset",
          description: "Try logging in with your new password.",
        })
        navigate("/")
      }
    } catch {
      toast({ title: "Network error", description: "Please check your internet connection", status: "error" })
    }
  }

  return (
    <VStack spacing={6}>
      <Box as={Logo} h={50} fill="gray.700" />
      <Text color="gray.700">Enter a new password below.</Text>
      <Form {...form} onSubmit={handleSubmit}>
        <Input name="password" placeholder="*********" type="password" />
        <Button width="100%" colorScheme="green" type="submit" isDisabled={isLoading} isLoading={isLoading}>
          Reset
        </Button>
        <Link to="/">Go to login page</Link>
      </Form>
    </VStack>
  )
}
